import React from 'react';
import { Emoji } from './Emoji';
export function Garantia() {
  return <section className="w-full bg-white py-12 sm:py-16" data-id="element-111" data-mp="1x5dkn6h0phvy">
      <div className="mx-auto w-full max-w-[680px] px-4 sm:px-6 lg:max-w-[820px]" data-id="element-112" data-mp="1x5voop9x90ef">
        <div className="rounded-3xl border-2 border-gold-400 bg-gold-100 px-5 py-8 text-center sm:px-10 sm:py-10" data-id="element-113" data-mp="223f0lij5d137">
          <Emoji symbol="🛡️" className="mx-auto block text-5xl" data-id="element-114" data-mp="2754ed5xr7suz" />
          <h2 className="mt-5 font-display text-[clamp(1.3rem,5.5vw,1.875rem)] font-extrabold uppercase tracking-tight text-ink-900" data-id="element-115" data-mp="2b5wqq81xadvh">
            Garantía 7 días — sin preguntas
          </h2>
          <p className="mx-auto mt-5 max-w-lg text-[14px] leading-relaxed text-ink-700 sm:text-[15px]" data-id="element-116" data-mp="2kuenme7300tu">
            Descargás los tomos. Los usás en tu cocina. Si en 7 días no es
            exactamente lo que esperabas, escribís a{' '}
            <a href="mailto:closethegap14@gmail.com" className="break-all font-semibold text-celeste-700 underline underline-offset-2" data-id="element-117" data-mp="2uup2024ureal">
              closethegap14@gmail.com
            </a>{' '}
            y te devolvemos el{' '}
            <strong className="font-bold text-ink-900" data-id="element-118" data-mp="3amd1ia5dquth">
              100% de tu dinero
            </strong>
            . Sin formularios. Sin drama. Sin explicaciones.
          </p>
          <p className="mt-4 text-[13px] font-bold text-gold-800 sm:text-sm" data-id="element-119" data-mp="30oyneh6xii4c">
            Tasa de devoluciones: menos del 1%.
          </p>
          <p className="mx-auto mt-4 max-w-lg text-[13px] text-ink-500 sm:text-sm" data-id="element-120" data-mp="269wkc5njk8u">
            Podemos ofrecer esta garantía porque sabemos lo que el sistema hace
            cuando alguien realmente lo usa.
          </p>
        </div>
      </div>
    </section>;
}